import { render } from "./company-redirect-button.vue?vue&type=template&id=4ace71c8"
import script from "./company-redirect-button.vue?vue&type=script&lang=js"
export * from "./company-redirect-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__